import React from 'react';

export default function About() {
  return (
    <section id="about">
      <div className="container-x">
        <header className="section-head">
          <h2 data-reveal="">A curious developer who lives <em>between layers.</em></h2>
        </header>
        <div className="about-grid">
          <aside className="col-meta" data-reveal="">
            <div className="pair"><span>— Studying</span><span className="v">Epitech · PGE/Bachelor</span></div>
            <div className="pair"><span>— Speaks</span><span className="v">FR · EN · RU</span></div>
            <div className="pair"><span>— Tools</span><span className="v">VIM &lt;3 · VSCode · Blender</span></div>
            <div className="pair"><span>— Outside code</span><span className="v">Sport · Philosophy · Old cars</span></div>
          </aside>
          <div className="about-body">
            <p data-reveal="" data-reveal-delay="1">
              I'm a <span className="hl">versatile and curious developer</span> who thrives at the intersection
              of high-level creativity and low-level technical depth — from React applications to
              systems programming, COBOL, and game modding.
            </p>
            <p data-reveal="" data-reveal-delay="2">
              I love understanding how things work under the hood, then bending them to my will.
              Reverse engineering, optimizing legacy code, or crafting smooth user experiences —
              I enjoy solving problems in unconventional ways and constantly learning along the journey.
              Outside of dev work I stay active by practicing sports, reading philosophy, and working on my old cars.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
